import { Suspense } from 'react'

import { Outlet } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

const BankCompaniesWrapper = () => (
  <Suspense fallback={<CircularProgress centered />}>
    <Outlet />
  </Suspense>
)

export default BankCompaniesWrapper
